<template>
  <div class="operation-management">
    <!--顶部按钮 -->
    <div class="management-header-btn">

      <el-button class="btn" @click="goback()">返回</el-button>
      <el-button class="btn" v-if="checkDownload()" @click="download()">下载</el-button>
    </div>
    <!-- 顶部按钮结束 -->
    <!-- 搜索框 -->
    <div class="management-header-content">
      <!-- 第一行内容 -->
      <el-row :gutter="20">
        <!-- 作业名称 -->
        <el-col :span="6">
          <div class="double-content">
            <div class="text">作业名称</div>
            <div class="main">
              <el-select   filterable placeholder="全部" v-model="form.homeworkId" :clearable=true>
                <el-option v-for="(item, index) in homeworkData" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        <!-- 姓名 -->
        <el-col :span="6">
          <div class="double-content">
            <div class="text">姓名</div>
            <div class="main-lesson">
              <el-input v-model="form.username" placeholder="姓名"></el-input>
            </div>
          </div>
        </el-col>
        <!-- 提交时间 -->
        <el-col :span="6" style="margin-left:0px;">
          <div class="double-content">
            <div class="text">提交时间</div>
            <div class="main">
              <el-date-picker size="medium" v-model="timeVal" type="daterange" @change="onTime" range-separator="-"
                :disabledDate="true" format="yyyy-MM-dd" value-format="yyyy-MM-dd" start-placeholder="开始日期"
                end-placeholder="结束日期"></el-date-picker>
            </div>
          </div>
        </el-col>
        <!-- 按钮 -->
        <el-col :span="6">

          <div class="btn-body-left">

            <div class="btn-and-more">
              <div style="padding: 0px;
                margin-left: 26px;
                color:#252628FF;
                font-size: 15px;
                margin-top: 9px;
               " type="text" cursor: pointer @click="moreList = !moreList" v-bind:class="{
                 'el-icon-arrow-up': moreList,
                 'el-icon-arrow-down': !moreList,
               }">
                &nbsp;<div style="margin: -15px 0 0 -65px;cursor: pointer;">{{ moreList ? "收起" : "展开" }}</div>
              </div>

              <div class="btn-all">
                <el-button class="reset-btn" @click="clear()">重置</el-button>
                <el-button class="select-btn" v-if="checkSelect()" @click="queryList()">查询</el-button>
              </div>
            </div>



          </div>



        </el-col>
      </el-row>




      <!-- 第二行内容 -->
      <el-row v-show="moreList" :gutter="20">
        <!-- 批改状态 -->
        <el-col :span="6">
          <div class="double-content">
            <div class="text">批改状态</div>
            <div class="main">
              <el-select filterable placeholder="全部" v-model="form.homeworkCheck" :clearable=true>
                <el-option v-for="(item, index) in homeworkCheckStatus" :key="index" :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        <!-- 岗位 -->
        <el-col :span="6">
          <div class="double-content">
            <div class="double-style">
              <div class="text">岗位</div>
              <div class="main-text-trainer">
                <el-select  filterable placeholder="全部" v-model="form.positionId" :clearable=true>
                  <el-option v-for="(item, index) in positonData" :key="index" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>

          </div>
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="6"></el-col>
      </el-row>

    </div>
    <!-- 搜索框结束 -->


    <!-- 作业表单数据 -->
    <!-- 作业表单数据 -->
    <div class="management-main">


      <el-card class="card-style">
        <el-table v-loading="dataListLoading" :data="tableData" :border="false" tooltip-effect="light"
          @row-click="toggleSelection" ref="multipleTable" :row-style="pointerStyle"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <!-- <el-table-column
          type="index"
          show-overflow-tooltip
          label="序号"
        ></el-table-column>
        <el-table-column
        show-overflow-tooltip
          prop="homeworkName"
          label="作业名称"
          min-width="120"
        ></el-table-column> -->
          <el-table-column prop="realName" show-overflow-tooltip label="姓名" min-width="50"></el-table-column>
          <el-table-column prop="positionNameCn" show-overflow-tooltip label="岗位"></el-table-column>
          <el-table-column prop="companyName" label="公司名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="mobile" label="联系电话">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="email" label="联系邮箱">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="pubDate" label="提交时间">
            <template slot-scope="scope">
              {{ formatDate(scope.row.pubDate) }}
            </template>
          </el-table-column>

          <el-table-column show-overflow-tooltip prop="approvalStatus" label="修改状态" align="center">
            <template slot-scope="scope">
              {{ getHomeworkCheck(scope.row.approvalStatus) }}
            </template>

          </el-table-column>
          <el-table-column width="117px" height="52px" fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <!-- 查看 -->
              <div class="colum-right-style" v-if="scope.row.approvalStatus != 2 && scope.row.approvalStatus != 8">
                <el-tooltip content="查看" placement="bottom" effect="light">
                  <span>
                    <div>
                      <img v-if="checkCheck()" @click.stop="handleClickMarking(scope.row)"
                        src="@/assets/img/course/check@2x.png" class="picIcon" alt="" />

                    </div>
                  </span>
                </el-tooltip>
                <img v-if="!checkCheck()" @click.stop="handleClickMarkingBlock()"
                  src="@/assets/img/course/check_block@2x.png" class="picIcon" alt="" />
              </div>
              <!-- 批改 -->
              <div class="colum-right-style" v-else-if="scope.row.approvalStatus == 2 || scope.row.approvalStatus == 8">
                <el-tooltip content="审批" placement="bottom" effect="light">
                  <span @click="handleClickMarking(scope.row)">
                    <div>
                      <img v-if="checkMarking()" @click.stop="handleClickMarking(scope.row)"
                        src="@/assets/img/course/marking2x.png" class="picIcon" alt="" />

                    </div>
                  </span>
                </el-tooltip>
                <img v-if="!checkMarking()" @click.stop="script(0)" src="@/assets/img/course/edit copy 7@2x.png"
                class="picIcon" alt="" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <div class="pagination-select">
        <el-pagination :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="totalCount"
          layout="total,prev,pager,next,sizes,jumper" @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
      </div>
    </div>

    <!-- 返回弹窗 -->
    <el-dialog :visible.sync="dialogVisibleReurn" custom-class="dialogVisibleReurnResource">
      <div class="dialog-modl">
        <div>
          <img src="@/assets/img/course/dialogIcon.png" alt="" />
        </div>
        <div class="dialog-modl-right">
          返回上一级,信息不会被保存,确认返回吗？
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleReurn = false" class="dialog-footer-btn">取 消</el-button>
        <el-button type="primary" style="margin-left: 16px" @click="goback()" class="dialog-footer-btn">确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 下载提示弹窗 -->
    <el-dialog :visible.sync="dialogVisibleDownLoad" custom-class="dialogVisibleReurnResource">
      <div class="dialog-modl">
        <div>
          <img src="@/assets/img/course/dialogIcon.png" alt="" />
        </div>
        <div class="dialog-modl-right">
          是否下载Zip作业文件【{{ this.homeworkName }}】？
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDownLoad = false" class="dialog-footer-btn">取 消</el-button>
        <el-button type="primary" style="margin-left: 16px" @click="homeworkDownIDSResult()" class="dialog-footer-btn">确
          定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      // 公司数据
      // resultCourseSlect:[],
      // check-box行点击数据
      multipleSelection: [],
      // 搜索框数据
      dialogVisibleDownLoad: false,
      homeworkDownloadListResult: "",
      dataListLoading: false,
      homeworkData: [],
      moreList: true,
      courseId: "",
      page: 1,
      limit: 10,
      totalCount: 0,
      tableData: [],
      timeVal: "",
      startTime: "",
      endTime: "",
      form: {
      "username":"",
      "homeworkId" : "",
      "homeworkCheck" : "",
      "startTime" : "",
      "endTime" :"",
      "positionId" : "",

      },
      positonData: [],
      homeworkCheckStatus: [{
          name: '待培训师审批',
          code: 1
        }, {
          name: '待店内审批',
          code: 2
        }, {
          name: '待区域经理审批',
          code: 3
        }, {
          name: '已审批',
          code: 4
        }, {
          name: '未通过',
          code: 5
        }],
      homeworkDownloadList: [],
      homeworkDownloadId: "",
      dialogVisibleReurn: false,
      downloadUrl: "",
      homeworkName: "",
    };
  },
  methods: {
//     querySearch(queryString){
//   this.$request
//         .post(`/course/homework/getCompanyDetail?companyName=${queryString}`, {
//           // ps: {
//           //   pageNo: 1,
//           //   pageSize: 20,
//           // },
//           // courseSearchVO: {
//           //   courseName: queryString,
//           // },
//         })
//         .then((res) => {
//          console.log(res,"名称查询数据")
//          this.resultCourseSlect=res
//          this.resultCourseSlect=this.resultCourseSlect.map((item=>{
//           item.value=item.nameCn
//           item.lable=item.companyId
//           return item
//          }))
//         }).catch(()=>{});






// },

    // 查询按钮权限
    checkSelect() {
      if (this.$hasPermission("joy:learning:courseoperation:select")) {
        return true;
      }
      return false;
    },
    // 下载按钮权限
    checkDownload() {
      if (this.$hasPermission("joy:learning:courseoperation:download")) {
        return true;
      }
      return false;
    },
    // 批改按钮权限
    checkMarking() {
      if (this.$hasPermission("joy:learning:courseoperation:marking")) {
        return true;
      }
      return false;
    },
    // 查看按钮权限
    checkCheck() {
      if (this.$hasPermission("joy:learning:courseoperation:checkSecond")) {
        return true;
      }
      return false;
    },

    homeworkDownIDSResult() {
      window.open(this.downloadUrl);
      this.dialogVisibleDownLoad = false;
    },
    // 手
    pointerStyle() {
      return {
        cursor: "pointer",
        fontSize: "14px",
        fontFamily: "PingFang SC-Regular, ingFangSC-Regular, sans-serif",
        fontWeight: 400,
        color: "#252628"
      };
},
    // 表格行事件
    toggleSelection(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },

    // 下载后文件
    homeworkDownIDS() {
      this.dataListLoading = true;
      this.$request
        .post(
          `/course/homeworkDownload/checkHomeworkDownloadIsOK?homeworkDownloadId=${this.homeworkDownloadId}`,
          {}
        )
        .then((res) => {
          console.log(res, "homeworkDownloadId");
          if (res.downloadUrl == null) {
            this.homeworkDownIDS();
          } else {
            this.dataListLoading = false;
            this.dialogVisibleDownLoad = true;
            this.downloadUrl = res.downloadUrl;
            this.homeworkName = res.homeworkName;
            console.log(this.downloadUrl, "this+downloadUrl");
          }
        });
    },
    goback() {
      this.tabRemove(this.$store.state.contentTabsActiveName)
    },
    // 返回删除meta
    tabRemove(tabName) {
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          path: "/manage/learning-course-courseOperation-OperationsManagement",
        });
      }
    },
    // 返回弹窗
    handleReturn() {
      this.dialogVisibleReurn = true;
    },
    // 下载
    download() {
      this.dataListLoading = true;
      if (
        this.homeworkDownloadListResult == "" ||
        this.homeworkDownloadListResult == null
      ) {
        this.$message.warning("请先选择需要下载的文件");
        this.dataListLoading = false;
        return;
      }

      this.$request
        .post(
          `/course/homeworkDownload/addHomeworkDownLoad?courseId=${this.courseId}&submitIds=${this.homeworkDownloadListResult}`,
          {}
        )
        .then((res) => {
          this.dataListLoading = false;
          this.homeworkDownloadId = res;
          if (this.homeworkDownloadId) {
            this.homeworkDownIDS();
          }
          // this.dialogVisibleDownLoad=true
        });
    },
    // 复选框
    handleSelectionChange(val) {
      console.log(val, "选中的数据");
      this.homeworkDownloadList = [];
      val.map((item) => {
        this.homeworkDownloadList.push(item.homeworkSubmitId);
      });

      this.homeworkDownloadList = this.fn3(this.homeworkDownloadList);
      let arr = this.homeworkDownloadList;
      arr = arr.join(",");
      this.homeworkDownloadListResult = arr;
      console.log(this.homeworkDownloadListResult, "this.homeworkDownloadList");
    },
    // 重置按钮
    clear() {
      this.timeVal = "";
      this.form.username = "";
      this.form.homeworkId = "";
      this.form.homeworkCheck = "";
      this.form.startTime = "";
      this.form.endTime = "";
      this.form.positionId = "";
      this.page=1
      this.getData();
      this.getDataList()
    },
    // 批改作业跳转
    handleClickMarking(row) {
      const courseId = this.courseId;
      this.$router.push({
        path: "/operationMarking",
        query: { show: JSON.stringify(row), courseId: courseId },
      });
      this.$eventHub.$emit("show", row);
      this.$eventHub.$emit("courseId", courseId);
    },
    handleClickMarkingBlock() {
      console.log(0);
    },
    // 查询数据
    queryList() {
      this.page=1;
      this.getData();
    },
    // 时间加一天
    getDay(beginDate, days) {
      var beginDate = beginDate.split("-");
      var nDate = new Date(
        beginDate[1] + "-" + beginDate[2] + "-" + beginDate[0]
      ); //转换为MM-DD-YYYY格式
      var millSeconds = Math.abs(nDate) + days * 24 * 60 * 60 * 1000;
      var rDate = new Date(millSeconds);
      var year = rDate.getFullYear();
      var month = rDate.getMonth() + 1;
      if (month < 10) month = "0" + month;
      var date = rDate.getDate();
      if (date < 10) date = "0" + date;
      return year + "-" + month + "-" + date;
    },
    onTime(val) {
      console.log(val);
      if (val == null) {
        this.form.startTime = "";
        this.form.endTime = "";
      }
      this.form.startTime = val[0];
      this.form.endTime = val[1];
      if (this.form.startTime == this.form.endTime) {
        this.form.endTime = this.getDay(this.form.endTime, 1);
      }
    },
    getHomeworkCheck(type) {
      switch (type) {
        case 0: return '未完成';
        case 1: return '待店内审核';
        case 2: return '待培训师审批';
        case 3: return '已审批';
        case 4: return '逾期未提交';
        case 5: return '已审批';
        case 6: return '未通过';
        case 7: return '未通过';
        case 8: return '待培训师审批';
        case 9: return '待区域经理审批';
        case 11: return '未通过';
        case 20: return '未通过';
        case 35: return '未通过';
        case 30: return '待培训师审批';
        case 40: return '已审批';
        case 50: return '逾期未提交';
        default: return '—';
      }
    },
    // 时间格式化
    formatDate(date, format = "YYYY-MM-DD HH:mm:ss") {
      return moment(date).format(format);
    },
    // 数组去重
    fn2(arr) {
      const res = new Map();
      return arr.filter(
        (arr) => !res.has(arr.label) && res.set(arr.label, arr.label)
      );
    },
    fn3(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr) && res.set(arr));
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.page = 1;
      this.limit = val;
      this.getData();
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.page = val;
      this.getData();
    },

    // 表格数据
    getData() {
      this.dataListLoading = true;
      this.$request
        .post("/course/homework/submitGetList", {
          ps: {
            pageNo: this.page,
            pageSize: this.limit,
          },
          courseHomeworkDetailSearchVO: {
            courseId: this.courseId,
            usename: this.form.username,
            homeworkId: this.form.homeworkId,
            homeworkCheck: this.form.homeworkCheck,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            positionId: this.form.positionId,
            companyId:this.form.companyId,
          },
        })
        .then((res) => {
          this.dataListLoading = false;
          this.tableData = res.data;
          this.totalCount = res.totalCount;
          // const datass = res.data;
          // datass.map((item) => {
          //   this.homeworkData.push({
          //     value: item.homeworkId,
          //     label: item.homeworkName,
          //   });
          //   this.positonData.push({
          //     value: item.positionId,
          //     label: item.positionNameCn,
          //   });
          // });
          // this.homeworkData = this.fn2(this.homeworkData);
          // this.positonData = this.fn2(this.positonData);
          console.log(this.homeworkData, "this.homeworkData");
        });
    },
    getDataList() {
      this.$request
        .post("/course/homework/submitGetList", {
          ps: {
            pageNo: 1,
            pageSize: 999,
          },
          courseHomeworkDetailSearchVO: {
            courseId: this.courseId,
            usename: this.form.username,
            homeworkId: this.form.homeworkId,
            homeworkCheck: this.form.homeworkCheck,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            positionId: this.form.positionId,
            companyId:this.form.companyId,
          },
        })
        .then((res) => {
          const datass = res.data;
          let newHomeworkData=[];
          let newPositionData=[];
          datass.map((item) => {
            newHomeworkData.push({
              value: item.homeworkId,
              label: item.homeworkName,
            });
            newPositionData.push({
              value: item.positionId,
              label: item.positionNameCn,
            });
          });
          this.homeworkData = this.fn2(newHomeworkData);
          this.positonData = this.fn2(newPositionData);
          console.log(this.positonData, "this.positonData");
        });
    },
  },
  created() {
    (this.dialogVisibleDownLoad = false),
      (this.homeworkDownloadListResult = ""),
      (this.dataListLoading = false),
      (this.moreList = true),
      //  this. courseId="",
      (this.page = 1),
      (this.limit = 10),
      (this.totalCount = 0),
      (this.moreList = true),
      (this.tableData = []),
      (this.timeVal = ""),
      (this.startTime = ""),
      (this.endTime = ""),
      (this.homeworkDownloadList = []),
      (this.homeworkDownloadId = ""),
      (this.dialogVisibleReurn = false),
      // 强制渲染组件
      this.$forceUpdate();
    this.$eventHub.$on("show", (row) => {
      const id = row.courseId;
      this.courseId = id;
    });
    this.$eventHub.$on("courseId", (courseId) => {
      const id = courseId;
      this.courseId = id;
      console.log(courseId, "courseId+++9");
    });
    if (!this.courseId) {
      if (this.$route.query.show) {
        let show = JSON.parse(this.$route.query.show);
        this.courseId = show.courseId;
      }
      if (this.$route.query.courseId) {
        let show = this.$route.query.courseId;
        this.courseId = show;
      }
    }
    this.getData();
    this.getDataList();
  },
  watch: {
    $route(to, from) {
      if (to) {
        this.getData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.picIcon{
  cursor: pointer;
  margin-left: 5px;
  width: 20px!important;
}
// 框圆角
.el-input__inner {
  border-radius: 4px !important;
}

.operation-management {
  display: flex;
  flex-direction: column;
  row-gap: 18px;
  width: 100%;
  height: 100%;

  // 分页器样式
  .el-pagination {
    display: flex;
    float: right;
    padding: 8px 3px 21px 0;
    margin-right: 9px;

    .el-pagination__jump {
      margin-left: 1px !important;
    }

    .el-pager {
      display: flex;
      flex-direction: row;
      column-gap: 9px;

      .number.active {
        color: #ffffff !important;
        background: #1c69d4ff !important;
        border-radius: 2px !important;
      }

      .number {
        width: 30px;
        height: 29px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #dfe0e2;
      }
    }

    .btn-prev {
      height: 29px;
      background: #ffffff;
      border-radius: 1px;
      border: 1px solid #dfe0e2;
      margin-right: 10px;
      margin-left: 7px;
    }

    .btn-next {
      height: 29px;
      background: #ffffff;
      border-radius: 1px;
      border: 1px solid #dfe0e2;
      margin-right: 4px;
      margin-left: 10px;
    }
  }

  // 作业头部按钮开始
  .management-header-btn {
    width: 100%;
    height: 50px;
    background: #ffff;

    .btn {
      width: 76px;
      height: 32px;
      background: #1c69d4;
      color: #fff;
      border-radius: 4px !important;
      float: right;
      margin: 9px 12px 4px 0;
    }
  }

  // 作业头部内容开始
  .management-header-content {
    height: 100%;
    background: #fff;
    padding: 18px 16px 18px 16px;
    display: flex;
    flex-direction: column;
    row-gap: 20px;

    .btn-and-more {
      margin: 24px -4px 0 -4px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      white-space: nowrap;
      float: right;
    }

    // 时间样式
    .el-range-input {
      background: none !important;
    }

    .el-date-editor {
      .el-range-separator{
        padding: 0px;
      }
      width: 101%;
      height: 30px;
      .el-range-input{
        font-size: 12px;
        width: 100%;
      }
    }

    .el-range-input {
      background: none;
    }

    .double-content {
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      .text{
        display: flex;
        justify-content: center;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
       font-weight: 400;
       color: #252628;
       line-height: 6px;

      }
      .main{
        width: 100%;
      }

      .main-text-trainer {
        width: 100%;
      }

      .double-style {
        display: flex;
       flex-direction: column;
       row-gap: 20px;
       width: 100%;

        .text {
          display: flex;
          justify-content: flex-start;
        }
      }

      .text {
        white-space: nowrap;
        display: flex;
        justify-content: flex-start;
      }

      .el-date-picker {
        width: auto !important;
      }

      .main-text {
        width: 202px;
        height: 28px;
      }

      .main-lesson {
        width: 100%;
        .el-input__inner {
          height: 22px;
        }
      }
    }

    // 按钮布局
    .btn-all {
      float: right;
    }

    .reset-btn {
      border-radius: 4px !important;
      width: 76px;
      height: 32px;
      background: #ffffff;
      color: #1c69d4;
      border: 1px solid #1c69d4;
    }

    .reset-btn:focus {
      background: #fff !important;
    }

    .select-btn {
      border-radius: 4px !important;
      width: 76px;
      height: 32px;
      background: #1c69d4;
      color: #fff;
    }
  }

  // 作业头部内容结束
  // 作业表单布局开始
  .management-main {
    .card-style {
      padding-bottom: 36px;
    }

    .el-card__body {
      padding-bottom: 63px;
    }

    .pagination-select {
      margin: -73px 9px 0 0;
    }
  }

  // 杂类样式
  .el-table {
    tr th,
    tr td {
      border-right: none !important;
    }
  }
}


</style>
<style lang="scss">
/* 表单头部颜色更改 */
.aui-wrapper .el-table th {
  background: #fafbff !important;
  border-right: 1px #dcdee3 solid;
}
.operation-management {
  .dialogVisibleReurnResource {
    width: 360px;
    height: 136px;
    background: #ffffff;
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
      0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 4px;

    .dialog-footer-btn {
      border-radius: 4px !important;
    }

    .el-dialog__headerbtn {
      position: absolute;
      top: 6px;
      right: 9px;
      padding: 0;
      background: 0 0;
      border: none;
      outline: 0;
      cursor: pointer;
      font-size: 16px;
    }

    .el-dialog__body {
      padding: 30px 20px;
      margin-top: -12px;
    }

    .el-dialog__footer {
      border: 0px !important;
      margin-top: -11px;
      margin-right: 15px;
    }

    .dialog-modl {
      height: 19px;
      display: flex;
      align-content: center;

      img {
        width: 24px;
        height: 24px;
        margin-right: 8px;
        margin-left: 9px;
        margin-top: -18px;
      }

      .dialog-modl-right {
        width: 280px;
        height: 24px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #252628;
        line-height: 24px;
        margin-top: -11px;
      }
    }
  }
}
</style>
